import {prepareFont} from '@assets/config/fonts/fonts';
import {createTheme} from '@mui/material/styles';
import {makeStyles} from '@mui/styles';
import {assignThemeColors, prepareDefaultColors} from '@assets/helpers/widget/themeHelpers';

export default function useTheme(settings) {
  const {
    brandColor,
    actionColor,
    btnPopupColor,
    headingTextFont,
    gradientColorOne,
    isGradient,
    welcomePopupSetting: wpSettings
  } = prepareDefaultColors(settings);

  assignThemeColors(settings);
  window.addEventListener('load', () => assignThemeColors(settings), false);

  const componentsOverrides = {
    MuiTypography: {
      styleOverrides: {
        h5: {fontWeight: 500},
        h6: {fontWeight: 400, lineHeight: '14.52px', fontSize: '11px'}
      }
    },
    MuiPaper: {
      styleOverrides: {
        elevation1: {boxShadow: '0 0 0 1px #3f3f440d, 0 1px 3px 0 #3f3f4426'},
        rounded: {borderRadius: '8px'}
      }
    },
    MuiChip: {styleOverrides: {label: {fontSize: '1.5em'}}},
    MuiTooltip: {styleOverrides: {tooltip: {fontSize: '1.5em'}, popper: {zIndex: 999999}}},
    MuiPopover: {styleOverrides: {root: {zIndex: '999999 !important'}}},
    MuiAlert: {styleOverrides: {message: {fontSize: '1.5em'}}},
    MuiInputBase: {
      styleOverrides: {
        input: {fontSize: '16px', '&:focus': {boxShadow: 'none !important'}},
        adornedEnd: {paddingRight: '0 !important'}
      }
    },
    MuiSnackbar: {styleOverrides: {root: {position: 'absolute'}}},
    MuiSnackbarContent: {styleOverrides: {root: {fontSize: '1em'}}},
    MuiButton: {
      styleOverrides: {
        containedPrimary: {color: actionColor},
        startIcon: {marginLeft: 0, marginRight: 0},
        endIcon: {marginLeft: 0, marginRight: 0},
        label: {overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}
      }
    },
    MuiListItemIcon: {styleOverrides: {root: {minWidth: 0}}},
    MuiMenuItem: {
      styleOverrides: {
        root: {gap: '6px', paddingTop: '4px', paddingBottom: '4px', padding: '4px 12px'}
      }
    },
    MuiListItemText: {styleOverrides: {primary: {fontSize: '12px'}}},
    MuiFab: {
      styleOverrides: {
        root: {height: '60px', width: '60px'},
        primary: {backgroundColor: btnPopupColor}
      }
    },
    MuiIconButton: {
      styleOverrides: {colorPrimary: {color: actionColor}, root: {padding: 0, borderRadius: 0}}
    },
    MuiTextField: {styleOverrides: {root: {borderRadius: '20px'}}},
    MuiListItem: {styleOverrides: {button: {padding: '0 5px', borderRadius: '5px'}}},
    MuiSlider: {styleOverrides: {markActive: {backgroundColor: brandColor}}},
    MuiOutlinedInput: {
      styleOverrides: {root: {borderRadius: '6px'}, input: {boxShadow: 'none !important'}}
    }
  };

  const theme = createTheme({
    palette: {
      primary: {main: isGradient ? gradientColorOne : brandColor},
      secondary: {main: actionColor}
    },
    typography: {
      pxToRem: px => px / 1.6,
      button: {fontSize: '1em', textTransform: 'unset'},
      fontFamily: 'inherit'
    },
    components: componentsOverrides,
    shape: {borderRadius: '0.5em'}
  });

  const useStyles = makeStyles(() => ({
    formLayout: {'& > *+*': {marginTop: '1em !important'}},
    headingText: {fontFamily: prepareFont(headingTextFont)},
    WPTitleTextFont: {fontFamily: prepareFont(wpSettings.titleTextFont || 'Inter')},
    WPMessageTextFont: {fontFamily: prepareFont(wpSettings.messageTextFont || 'Inter')},
    '@global': {
      '.AvadaFaqs-MUI-formLayoutFAQ > *+*': {marginTop: '1em !important'},
      '.AvadaFaqs-MUI-headingText': {fontFamily: prepareFont(headingTextFont)},
      '.AvadaFaqs-MUI-WPTitleTextFont': {
        fontFamily: prepareFont(wpSettings.titleTextFont || 'Inter')
      },
      '.AvadaFaqs-MUI-WPMessageTextFont': {
        fontFamily: prepareFont(wpSettings.messageTextFont || 'Inter')
      }
    }
  }));
  const classes = useStyles();
  return {theme, classes};
}
